import React from 'react';
import { useNavigate } from 'react-router-dom';
import ROUTES from '../../services/Constants/GlobalRoutes.jsx';
import InfoIcon from '../../assets/InfoIcon.jsx';
import ExploreOffersBanner from '../../assets/ExploreOffersBanner.png';
import './VoucherExhaustedView.css';

/**
 * @returns {JSX.Element} VoucherExhaustedView Component
 */
export default function VoucherExhaustedView() {
  const navigateTo = useNavigate();

  return (
    <div className='infoBox-and-banner'>
      <div className='voucher-info-boxs'>
        <div className='voucher-info-icon'>
          <InfoIcon />
        </div>
        <div className='voucher-info-content'>
          <div className='voucher-info-title'>No vouchers left for now</div>
          <div className='voucher-info-subtitles'>
            You&apos;ve made the most of your vouchers this month. Fresh vouchers
            arrive on the 1st of every month
          </div>
        </div>
      </div>
      <div className='explore-offers-banner'>
        <img
          className='explore-offers-image'
          alt='ExploreOffersBanner'
          src={ ExploreOffersBanner }
        />
        <button
          className='secondary-button explore-offers-button'
          onClick={ () => navigateTo(ROUTES.HOME) }
        >
          Explore More Offers
        </button>
      </div>
    </div>
  );
}
